import React from 'react';
import { Subscription } from '@wix/ambassador-billing-v1-subscription/types';
import { SectionNotification, Text } from 'wix-ui-tpa';
import { Info } from '@wix/wix-ui-icons-common/on-stage';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { connect } from '../../../../common/components/runtime-context';
import { RootState } from '../../state';
import { formatDate } from '../../../../utils/displayUtils';
import { getRegionalSettings } from '../../selectors';
import { getBillingCycleDate, getSkipCyclesCount, isCurrentlySkipping, toDate } from '../../domainUtils';

export const SKIP_SECTION_HELPER_DATA_HOOKS = {
  currentlySkipping: 'skip-currently-section-helper',
  scheduledSkip: 'skip-scheduled-section-helper',
};

type RuntimeProps = ReturnType<typeof mapRuntimeToProps>;

interface Props {
  subscription: Subscription;
}

const SkipSectionHelper = ({ subscription, regionalSettings }: Props & RuntimeProps) => {
  const { t } = useTranslation();
  const currentlySkipping = isCurrentlySkipping(subscription);

  let message: string;
  if (currentlySkipping) {
    const resumeCycle = subscription.pauseInfo?.resumeCycle ?? 0;
    const resumeDate = toDate(subscription.pauseInfo?.resumeDate) ?? getBillingCycleDate(subscription, resumeCycle);
    message = t('app.subscription-status.activeSkippingOrder.dateInfoMessage', {
      resumeDate: formatDate(resumeDate, regionalSettings),
    });
  } else {
    const startCycle = subscription.pauseInfo?.startCycle ?? 0;
    const count = getSkipCyclesCount(subscription);
    message = t('app.subscription-status.activeSkip.dateInfoMessage', {
      count,
      startDate: formatDate(getBillingCycleDate(subscription, startCycle), regionalSettings),
      endDate: formatDate(getBillingCycleDate(subscription, startCycle + count - 1), regionalSettings),
    });
  }

  return (
    <SectionNotification
      type="wired"
      data-hook={
        currentlySkipping
          ? SKIP_SECTION_HELPER_DATA_HOOKS.currentlySkipping
          : SKIP_SECTION_HELPER_DATA_HOOKS.scheduledSkip
      }
    >
      <SectionNotification.Icon icon={<Info />} />
      <SectionNotification.Text>
        <Text>{message}</Text>
      </SectionNotification.Text>
    </SectionNotification>
  );
};

const mapRuntimeToProps = (state: RootState, _props: Props) => {
  return {
    regionalSettings: getRegionalSettings(state),
  };
};

export default connect(mapRuntimeToProps)(SkipSectionHelper);
